import React from "react";
import { numberFormattingContext } from "app/formatting/context";
import { formatDecimal, formatMoney } from "app/formatting/functions";

export const useContextualDecimalFormatter = () => {
    const context = React.useContext(numberFormattingContext);

    return (inValue: number) => formatDecimal(inValue, context.fractionDigits);
};

export const useContextualMoneyFormatter = () => {
    const context = React.useContext(numberFormattingContext);

    return (inValue?: number | null, currency?: string | null) =>
        formatMoney(inValue, currency, context.fractionDigits);
};
